/**
 * RTWO Consensus Engine — Client-Safe Exports
 */

export type {
  ConsensusPhase,
  ValidatorCandidateStatus,
  EpochStatus,
  ConsensusHash,
  ConsensusAddress,
  RTWOConsensusState,
  RTWOValidatorCandidate,
  RTWOConsensusVote,
  RTWOEpoch,
} from './domain-models';

export {
  CONSENSUS_ENGINE_VERSION,
  CONSENSUS_PHASES,
  VALIDATOR_STATUSES,
  EPOCH_LIFECYCLE,
  CONSENSUS_SLASHING_RULES,
  PHASE4_READINESS_CHECKLIST,
  CONSENSUS_SERVICE_IDS,
  createEmptyConsensusState,
  createEmptyValidatorCandidate,
  createEmptyConsensusVote,
  createEmptyEpoch,
} from './domain-models';
